import { render, staticRenderFns } from "./ImageUploader.vue?vue&type=template&id=3ef5af1e&scoped=true"
import script from "./ImageUploader.vue?vue&type=script&lang=ts"
export * from "./ImageUploader.vue?vue&type=script&lang=ts"
import style0 from "./ImageUploader.vue?vue&type=style&index=0&id=3ef5af1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef5af1e",
  null
  
)

export default component.exports